<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>建筑编辑</span>
          <el-button type="primary" size="mini" style="margin: 5px 0px 0px 5px;" @click="go()">返回</el-button>
        </div>
        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="建筑ID">
              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="建筑ID" />
            </el-form-item>
            <el-form-item label="关卡配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="configVisibleArr[index].visible = true" />
              <el-dialog title="关卡配置" width="670px" :visible="configVisibleArr[index].visible">
                <el-form>
                  <el-row v-for="(e,i) in item.config" :key="i">
                    <el-form-item label="等级" style="margin-top: 10px;">
                      <el-select v-model="e.level" style="width: 100px" placeholder="请选择">
                        <el-option
                          v-for="item in selectType"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;" label="皮肤ID">
                      <el-input v-model.number="e.skin" :prop="'formData.'+index+'.config.' +i +'.skin'" style="width: 100px" autocomplete="off" />
                    </el-form-item>

                    <el-form-item style="margin-top: 10px;" label="获得车辆">
                      <el-input v-model.number="e.car" :prop="'formData.'+index+'.config.' +i +'.car'" style="width: 100px" autocomplete="off" />
                    </el-form-item>

                    <el-form-item>
                      <el-button style="margin-top: 10px;" type="danger" @click="removeEvent(index, i, 'config')">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item style="margin-top: 10px">
                    <el-button type="primary" @click="addEvent(index,'config')">+</el-button>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="configVisibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="configVisibleArr[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
          </el-row>
          <el-form-item>
            <!--            <el-button v-permisaction="['config:buildCfg:add']" type="primary" @click="add()">新增关卡</el-button>-->
          </el-form-item>
          <el-button v-permisaction="['config:buildCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportBuildCfg, updateBuildCfgList, getBuildCfgList } from '@/api/config/build-cfg'
export default {
  name: 'BuildConfigEdit',
  data() {
    return {
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      selectType: [
        {
          'id': 1,
          'title': '等级1'
        },
        {
          'id': 2,
          'title': '等级2'
        },
        {
          'id': 3,
          'title': '等级3'
        }, {
          'id': 4,
          'title': '等级4'
        },
        {
          'id': 5,
          'title': '等级5'
        }, {
          'id': 6,
          'title': '等级6'
        }
      ],
      cardsType: [
        {
          'id': 1,
          'title': '是'
        },
        {
          'id': 0,
          'title': '否'
        }
      ],
      formData: []
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      updateBuildCfgList({ name: this.id, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    go() {
      this.$router.push({ path: '/config/build-config/index', query: { }})
    },
    getTables() {
      getBuildCfgList({ name: this.id }).then(res => {
        for (let i = 0; i < 6; i++) {
          this.configVisibleArr.push({ visible: false })
        }

        this.formData = res.data[0].config
        console.log(this.formData)
        this.add()
      })
    },
    add() {
      const count = this.formData.length
      console.log('长度', this.formData.length)
      if (count < 6) {
        const c = 6 - count
        for (let i = 0; i < c; i++) {
          const id = i + 1
          this.formData.push({
            'id': id,
            'config': [
              {
                'id': 1,
                'level': 1,
                'skin': 0,
                'car': 0
              }
            ]
          })
          this.configVisibleArr.push({ visible: false })
        }
      }
    },
    edit(id) {
      this.$router.push({ path: '/config/build-config/edit', query: { id: id }})
    },
    exportData(name) {
      console.log(name)
      exportBuildCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addEvent(index, name) {
      const data = this.formData[index][name]
      let level = 0
      for (const i in data) {
        level += data[i].level
      }
      console.log(level)
      if (level >= 6) {
        this.msgError('等级最多6级')
        return false
      }
      this.formData[index][name].push({
        'id': 0,
        'level': 1,
        'skin': 0,
        'car': 1
      })
    },
    removeEvent(index, key, name) {
      this.formData[index][name] = this.formData[index][name].filter((item, k) => {
        return key !== k
      })
    }
  }
}
</script>

<style scoped>
</style>
